<script lang="ts">
  /* Icon-only row action — the sibling of RowActions for actions that are not
     edit/delete (view profile, browse products, unlink…). Same 30px circle,
     same hover tints, so a row's controls read as one family whichever
     component rendered them (2026-08-14 feedback: text links «Товары ·
     Профиль · Редакция · Удалить» become icons). The label survives as the
     tooltip and the accessible name. */

  type Props = {
    /** Material icon name (outlined set). */
    icon: string;
    /** Tooltip + aria-label — the text the icon replaced. */
    title: string;
    /** Renders as a link instead of a button. */
    href?: string;
    /** Open the link in a new tab (read-asides: profiles, catalogs). */
    newTab?: boolean;
    onclick?: (e: MouseEvent) => void;
    tone?: "default" | "primary" | "danger";
    disabled?: boolean;
  };

  let { icon, title, href, newTab = false, onclick, tone = "default", disabled = false }: Props = $props();
</script>

{#if href}
  <a
    class="icon-action icon-action--{tone}"
    {href}
    target={newTab ? "_blank" : undefined}
    rel={newTab ? "noopener" : undefined}
    {title}
    aria-label={title}
  >
    <span class="material-icons-outlined" aria-hidden="true">{icon}</span>
  </a>
{:else}
  <button
    type="button"
    class="icon-action icon-action--{tone}"
    {onclick}
    {disabled}
    {title}
    aria-label={title}
  >
    <span class="material-icons-outlined" aria-hidden="true">{icon}</span>
  </button>
{/if}

<style>
  .icon-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: var(--color-text-muted);
    cursor: pointer;
    text-decoration: none;
    transition: background 0.12s, color 0.12s;
  }
  .icon-action .material-icons-outlined { font-size: 18px; }
  .icon-action--primary { color: var(--color-primary); }
  .icon-action:hover:not(:disabled) {
    background: rgba(33, 133, 213, 0.1);
    color: var(--color-primary);
  }
  .icon-action--danger:hover:not(:disabled) {
    background: rgba(220, 38, 38, 0.1);
    color: #dc2626;
  }
  .icon-action:disabled { opacity: 0.35; cursor: default; }
  .icon-action:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 1px;
  }
</style>
